import { getData, getFirst, isValid, MAX_LIMIT } from 'clients/Clients';
import { getStoreInfoForWeb, searchSellerStoreV2, searchStoreByTextV2, searchVendorStore, searchVendorStoreV2 } from 'clients/SellerClient';
import { BRAND_NAME } from 'constants/Enums';
import ProductServiceV2 from 'services/ProductServiceV2';
import { DOMAIN_FLAGSHIP_STORE } from 'sysconfig';
import { sleep } from 'utils/helper';
import { CACHE_KEY, deserializeFunc, getWithExpiry, serializeFunc, setWithExpiry } from 'utils/localStorageUtils';

/**
 * from the seller, fill data like name, link to store...
 * @param {object} param0
 * @param {object} param0.seller
 * @param {string[]=} param0.tags
 * @param {boolean=} param0.isSkipShortName
 * @returns
 * @example
 * const seller = getSellerData({ seller: mapSeller.get(seller.code) });
 */
export function getSellerData({ seller = {}, tags = [], isSkipShortName = false }) {
  const isVAT = tags?.indexOf('HOADONNHANH') >= 0 || false;

  let sellerName = '';
  let isDisplayStore = false;
  let fullNameSeller = '';
  let individualNonVatSellerName = '';
  const sellerCode = seller?.code || seller?.sellerCode;
  const sellerSlug = seller?.slug || '';

  let linkSeller = seller?.landingPage?.startsWith('https://try.thuocsi.vn')
    ? seller?.landingPage
    : `/seller-products/${sellerCode}/${seller?.slugStore || seller?.sellerType == 'ENTERPRISE' ? sellerSlug : ''}`;

  // nếu không có sellerinfo => hiện default
  if (seller) {
    if (seller.isInternal || seller.sellerClass == "INTERNAL") {
      isDisplayStore = true;
      fullNameSeller = seller.sellerName || seller.name || 'MEDX';
      if (isVAT) {
        sellerName = seller.shortName || seller.sellerCode || seller.code || 'MEDX';
      }
    } else if (seller?.sellerType === 'ENTERPRISE') {
      isDisplayStore = true;
      sellerName = seller?.name || '';

      if (!isSkipShortName) {
        if (seller.shortName) {
          sellerName = seller?.shortName;
        }

        // fallback for all case
        if (seller.displayName) {
          sellerName = seller?.displayName;
        }
      }

      fullNameSeller = seller?.fullName || '';
    } else {
      sellerName = `Đối Tác Của ${BRAND_NAME}`;
      individualNonVatSellerName = `Nhà bán hàng ${seller?.sellerID ?? ''}`;
      isDisplayStore = false;
      fullNameSeller = `Đối Tác Của ${BRAND_NAME}`;
      linkSeller = `/doitac/${sellerCode}`;
    }
  }

  const storeSlug = seller?.sellerStore?.slug || sellerSlug;
  const linkStore = seller?.isVip ? DOMAIN_FLAGSHIP_STORE.replace('{seller}', storeSlug) || `/flagship-store/${storeSlug}` : `/seller/${storeSlug}`;

  return {
    sellerName,
    linkStore,
    linkSeller,
    isDisplayStore,
    fullNameSeller,
    individualNonVatSellerName,
    ...seller,
  };
}

export async function getStoreInfo({ ctx, slug }) {
  const infoResult = await getStoreInfoForWeb({ ctx, slug });
  if (!isValid(infoResult)) {
    return null;
  }
  const storeInfo = getFirst(infoResult);
  const countTotalRes = await ProductServiceV2.loadProductWithFilter({ ctx, limit: 1, filter: { seller: storeInfo.sellerCode } });
  if (isValid(countTotalRes)) {
    storeInfo.numberProducts = countTotalRes.total;
    storeInfo.numberProductDisplay = countTotalRes.total;
  }

  return storeInfo;
}

export async function getListSearchStore({ ctx, body }) {
  const listStoreActiveRes = await searchSellerStoreV2({ ctx, body });
  if (!isValid(listStoreActiveRes)) {
    return null;
  }
  const data = getData(listStoreActiveRes);
  const { total } = listStoreActiveRes;
  // const topProductsRes = await Promise.all(promiseAll);
  // const topProductsArr = [];
  // topProductsRes.forEach((ele) => {
  //   topProductsArr.push(getData(ele));
  // });
  // const topProducts = topProductsArr.map((item) => {
  //   const sellerCode = item[0]?.sellerCode || '';
  //   return { sellerCode, topProducts: item };
  // });
  // const sellerMapTopProduct = data.map((item) => {
  //   const { code } = item;
  //   const obj = topProducts.find((ele) => ele.sellerCode === code);
  //   return { ...item, product: { sellerCode: code, topProducts: obj?.topProducts.slice(0, 3) || {} } };
  // });
  return { total, storeData: data };
}

export async function getSearchStoreByName({ ctx, params }) {
  const listStoreRes = await searchStoreByTextV2({ ctx, params });
  if (!isValid(listStoreRes)) {
    return null;
  }
  const data = getData(listStoreRes);
  const { total } = listStoreRes;

  // const topProductsArr = [];
  // topProductsRes.forEach((ele) => {
  //   topProductsArr.push(getData(ele));
  // });
  // const topProducts = topProductsArr.map((item) => {
  //   const sellerCode = item[0]?.sellerCode || '';
  //   return { sellerCode, topProducts: item };
  // });
  // const sellerMapTopProduct = data.map((item) => {
  //   const { code } = item;
  //   const obj = topProducts.find((ele) => ele.sellerCode === code);
  //   return { ...item, product: { sellerCode: code, topProducts: obj?.topProducts.slice(0, 3) || {} } };
  // });
  return { total, storeData: data };
}

export async function getVendorStoreInfo({ ctx, slug, getStoreInfo = false }) {
  const vendorStoreRes = await searchVendorStore({
    ctx,
    body: {
      q: { slug },
      getStoreInfo,
      queryForWeb: true,
    },
  });
  if (!isValid(vendorStoreRes)) {
    return null;
  }

  const vendorStore = getFirst(vendorStoreRes);

  const countTotalRes = await ProductServiceV2.loadProductWithFilter({ ctx, limit: 1, filter: { seller: vendorStore.sellerCode } });
  if (isValid(countTotalRes)) {
    vendorStore.numberProducts = countTotalRes.total;
    vendorStore.numberProductDisplay = countTotalRes.total;
  }

  return vendorStore;
}

export async function getVendorStoreList({ ctx, body }) {
  const listStoreActiveRes = await searchVendorStoreV2({ ctx, body });
  if (!isValid(listStoreActiveRes)) {
    return null;
  }
  const data = getData(listStoreActiveRes);

  const { total } = listStoreActiveRes;

  return { total, storeData: data };
}

/**
 * Get vendor store with status=ACTIVE from cache or fetch from API
 * @returns {Promise<Array>}
 */
export async function getCachedVendorStores() {
  const FIELDS = [
    'code',
    'name',
    'url',
    'slug',
    'landingPage',
    'logo',
    'allProductTag',
    'primaryColor',
    'titleColor',
    'backgroundColor',
    'borderAvatarColor',
  ];

  // Case 1: cache hit
  const cachedVendorStores = getWithExpiry(CACHE_KEY.VENDOR_STORES);
  if (cachedVendorStores) {
    return cachedVendorStores.map((data) => deserializeFunc(data, FIELDS));
  }

  // Case 2: cache miss -> Fetch missing data, then cache
  let res = await searchVendorStore({
    body: {
      offset: 0,
      limit: MAX_LIMIT,
      q: { status: 'ACTIVE' },
    },
  });
  if (res.status !== 'OK') {
    console.error('[Error] Get vendorStore', res);
    return [];
  }

  // Get all data if applicable
  let data = res.data || [];
  let allData = data;
  let offset = data.length;
  while (data.length === MAX_LIMIT) {
    res = await searchVendorStore({
      body: {
        offset,
        limit: MAX_LIMIT,
        q: { status: 'ACTIVE' },
      },
    });

    if (res.status !== 'OK') {
      break;
    }

    data = res.data;
    allData = allData.concat(data);
    offset += data.length;
  }

  const vendorStores = allData.filter((item) => item.status === 'ACTIVE').map((p) => serializeFunc(p, FIELDS));

  // Update cache
  setWithExpiry(CACHE_KEY.VENDOR_STORES, vendorStores);

  return vendorStores.map((data) => deserializeFunc(data, FIELDS));
}

let hasFlagshipStoreTagCount = 0;
/**
 * Check product tags to see if it has a vendor store tag
 * @param {Array<string>} productTags
 * @returns {Promise<boolean>}
 */
export async function hasFlagshipStoreTag(productTags = []) {
  if (productTags?.length <= 0) return false;
  if (productTags.indexOf('DUREX') >= 0) return true;
  if (productTags.indexOf('SANOFI') >= 0) return true;

  // HACK:
  // When the function is called for the first time, it will trigger API and
  // save to localStorage. The subsequent calls will wait for the cached data
  // to be available (assumption: the API is finished after 2 seconds).
  // If there is already a cached data, we don't need to wait
  hasFlagshipStoreTagCount += 1;
  if (hasFlagshipStoreTagCount > 1 && !localStorage.getItem(CACHE_KEY.VENDOR_STORES)) {
    await sleep(2);
  }

  const vendorStores = await getCachedVendorStores();

  // Loop though all vendor stores, check if productTags contains any of the allProductTag
  for (let i = 0; i < vendorStores.length; i++) {
    if (productTags.indexOf(vendorStores[i].allProductTag) >= 0) return true;
  }

  return false;
}
